import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  serviceNames = {
    1: 'Employer of Record',
    2: 'Agent of Record',
    3: 'Compliance'
  };

  serviceShortNames = {
    1: 'EOR',
    2: 'AOR',
    3: 'COM'
  };
  constructor() { }

  getServiceName = (serviceId) => {
    return this.serviceNames[serviceId];
    };
    htmlDecode(str): string {
        var div = document.createElement("div");
        div.innerHTML = str;
        return div.textContent || div.innerText;
    }
}
